var map = {
	"./Logo-2020-OK-grigio.png": "408c",
	"./arrow-carousel.png": "3599",
	"./certificato-qualità.png": "1068",
	"./collaboratori-image-1.png": "4edb",
	"./collaboratori-image-2.png": "c4d2",
	"./download-logo-full-en.png": "d079",
	"./download-logo-full-it.png": "0896",
	"./download-logo.svg": "7c48",
	"./favicon.png": "99dd",
	"./icon-attachment.png": "aa63",
	"./intro-bg.png": "3d3d",
	"./iusful-logo.png": "5985",
	"./lo-studio-image-1.png": "33d4",
	"./lo-studio-image-2.png": "a6b5",
	"./lo-studio-image-3.png": "8f20",
	"./logo.png": "cf05",
	"./map-contatti-mobile.png": "621a",
	"./map-contatti.png": "f305",
	"./network-map - Copia.png": "81547",
	"./network-map-mobile.png": "958d",
	"./network-map.png": "0f80",
	"./quality-logo.png": "c409",
	"./sez-bg.png": "51fc",
	"./sez-bg2.png": "aaf5",
	"./shadow-soci.png": "4f2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";